/**
 * #4386: better-auth's signOut resolves `{ error }` rather than throwing on a
 * 503 (a timed-out server). Redirecting anyway left the cookie in place while
 * the page looked signed out, so the caller needs to know which happened.
 */
export async function signOutFinished(signOutFn: () => Promise<unknown>): Promise<boolean> {
  try {
    const result = await signOutFn();
    return !(result && typeof result === "object" && (result as { error?: unknown }).error);
  } catch {
    return false;
  }
}

export const SIGN_OUT_FAILED_MESSAGE = "Sign-out didn't finish. Try again.";
